export interface ArtCandidate { id: string; bytes: number; lastUsed: number }

/** Plan only; no deletion unless the entire requested amount can be reclaimed. */
export function chooseArtEvictions(candidates: readonly ArtCandidate[], available: readonly string[], needed: number): string[] | null {
  if (needed <= 0) return [];
  const victims: string[] = [];
  for (const item of [...candidates].sort((a, b) => a.lastUsed - b.lastUsed || a.id.localeCompare(b.id))) {
    if (!available.includes(item.id)) continue;
    victims.push(item.id); needed -= item.bytes;
    if (needed <= 0) return victims;
  }
  return null;
}
